import { render } from "./TakeActionOnOne.vue?vue&type=template&id=20416bca&scoped=true"
import script from "./TakeActionOnOne.vue?vue&type=script&lang=js"
export * from "./TakeActionOnOne.vue?vue&type=script&lang=js"

import "./TakeActionOnOne.vue?vue&type=style&index=0&id=20416bca&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20416bca"]])

export default __exports__